import api from "../index";

export const GetEmailDetailApi = (params) => api.get(`Marketing/Get-Send-Email-Detail?${params}`);
export const SendMarketingEmailApi = (data) => api.post('Marketing/Send-Marketing-Email', data, { headers: { 'Content-Type': 'multipart/form-data' } });
